export { default } from './image.component';
